<!-- Tab -->
<div class="tab">
    <div
        class="tab-item"
        (click)="selectTab(TAB_ALARM)"
        [class.active]="openTab === TAB_ALARM"
    >
        {{ "forms.channel.tab-titles.alarm" | translate }}
    </div>
    <div
        class="tab-item"
        (click)="selectTab(TAB_ABOUT)"
        [class.active]="openTab === TAB_ABOUT"
    >
        {{ "forms.channel.tab-titles.about" | translate }}
    </div>
</div>

<div class="main-container-alarm" *ngIf="openTab === TAB_ALARM">
    <div class="header normal-padding">
        <div class="title-container">
            <div class="title">
                <div class="tag">{{ getTag() }}</div>
                <div class="name">{{ getName() }}</div>
                <div class="value-container">
                    <div
                        class="status-container"
                        alarmLevelColor
                        [channel]="channel"
                        [status]="status"
                    >
                        {{ statusText | translate }}
                    </div>
                    <span *ngIf="!isDigital()" class="value">
                        {{ getValue() + " " + getUnits() }}</span
                    >
                </div>
            </div>
            <div class="repose">
                <div class="caption">
                    {{ "forms.channel.alarm.manual-repose" | translate }}
                    <app-repose-toggle
                        #globalRepose
                        class="toggle-container"
                        [checked]="getGlobalReposeValue()"
                        (toggleCheckedClick)="onGlobalReposeClicked($event)"
                    ></app-repose-toggle>
                </div>
            </div>
        </div>

        <div class="alarm-graph-container" *ngIf="!isDigital()">
            <div class="channel-range-container">
                <app-channel-alarm-range
                    [channel]="channel"
                    [value]="getRawValue()"
                    [status]="status"
                ></app-channel-alarm-range>
                <div class="measurable-range highlighted text-large light">
                    <div>{{ getMeasurableMin() }}</div>
                    <div>{{ getMeasurableMax() }}</div>
                </div>
            </div>

            <app-alarm-range-list [channel]="channel"> </app-alarm-range-list>
        </div>
    </div>
    <div class="content normal-padding">
        <div class="alarm-container" *ngIf="isAnalog()">
            <app-alarm-setting-form
                #alarmSettingForm
                *ngIf="validators.veryHigh"
                [validator]="validators.veryHigh"
                title="channel.label.alarm.high-high"
                [disableFields]="['timer']"
                [alarm]="channel.fcuData.alarmSettingVeryHigh"
                [measurementUnits]="channel.opsData.measurementUnit"
                (onSubmit)="emitSubmit('alarmSettingVeryHigh', $event)"
                (onDelete)="emitDelete('alarmSettingVeryHigh', $event)"
                [channel]="channel"
                [userPermission]="userPermission"
            ></app-alarm-setting-form>
            <app-alarm-setting-form
                #alarmSettingForm
                *ngIf="validators.high"
                [validator]="validators.high"
                title="channel.label.alarm.high"
                [disableFields]="['timer']"
                [alarm]="channel.fcuData.alarmSettingHigh"
                [measurementUnits]="channel.opsData.measurementUnit"
                (onSubmit)="emitSubmit('alarmSettingHigh', $event)"
                (onDelete)="emitDelete('alarmSettingHigh', $event)"
                [channel]="channel"
                [userPermission]="userPermission"
            ></app-alarm-setting-form>
            <app-alarm-setting-form
                #alarmSettingForm
                *ngIf="validators.low"
                [validator]="validators.low"
                title="channel.label.alarm.low"
                [disableFields]="['timer']"
                [alarm]="channel.fcuData.alarmSettingLow"
                [measurementUnits]="channel.opsData.measurementUnit"
                (onSubmit)="emitSubmit('alarmSettingLow', $event)"
                (onDelete)="emitDelete('alarmSettingLow', $event)"
                [channel]="channel"
                [userPermission]="userPermission"
            ></app-alarm-setting-form>
            <app-alarm-setting-form
                #alarmSettingForm
                *ngIf="validators.veryLow"
                [validator]="validators.veryLow"
                title="channel.label.alarm.low-low"
                [disableFields]="['timer']"
                [alarm]="channel.fcuData.alarmSettingVeryLow"
                [measurementUnits]="channel.opsData.measurementUnit"
                (onSubmit)="emitSubmit('alarmSettingVeryLow', $event)"
                (onDelete)="emitDelete('alarmSettingVeryLow', $event)"
                [channel]="channel"
                [userPermission]="userPermission"
            ></app-alarm-setting-form>
            <app-alarm-setting-form
                #alarmSettingForm
                *ngIf="validators.feedback"
                [validator]="validators.feedback"
                title="channel.label.alarm.feedback"
                [isFeedbackAlarm]="true"
                [disableFields]="['setPoint']"
                [alarm]="channel.fcuData.alarmSettingFeedbackError"
                [measurementUnits]="channel.opsData.measurementUnit"
                (onSubmit)="emitSubmit('alarmSettingFeedbackError', $event)"
                (onDelete)="emitDelete('alarmSettingFeedbackError', $event)"
                [channel]="channel"
                [userPermission]="userPermission"
            ></app-alarm-setting-form>
            <app-alarm-setting-form
                #alarmSettingForm
                *ngIf="validators.sensorFail"
                [validator]="validators.sensorFail"
                title="channel.label.alarm.sensor-failure"
                [isFeedbackAlarm]="false"
                [alarm]="channel.fcuData.alarmSettingSensorFail"
                [measurementUnits]="channel.opsData.measurementUnit"
                [disableFields]="['setPoint', 'timer']"
                (onSubmit)="emitSubmit('alarmSettingSensorFail', $event)"
                (onDelete)="emitDelete('alarmSettingSensorFail', $event)"
                [channel]="channel"
                [userPermission]="userPermission"
            ></app-alarm-setting-form>
        </div>
        <div class="digital alarm-container" *ngIf="isDigital()">
            <app-alarm-setting-form
                #alarmSettingForm
                *ngIf="validators.alarmSetting"
                [validator]="validators.alarmSetting"
                title="channel.label.alarm.digital"
                [disableFields]="['setPoint', 'timer']"
                [alarm]="channel.fcuData.digitalAlarmSetting"
                [measurementUnits]="channel.opsData.measurementUnit"
                (onSubmit)="emitSubmit('digitalAlarmSetting', $event)"
                (onDelete)="emitDelete('digitalAlarmSetting', $event)"
                [channel]="channel"
                [userPermission]="userPermission"
            ></app-alarm-setting-form>
        </div>
        <div class="running-hour alarm-container" *ngIf="isRunningHour()">
            <app-alarm-setting-form
                #alarmSettingForm
                *ngIf="validators.veryHigh"
                [validator]="validators.veryHigh"
                title="channel.label.alarm.high-high"
                [disableFields]="['timer']"
                [alarm]="channel.fcuData.alarmSettingVeryHigh"
                [measurementUnits]="channel.opsData.measurementUnit"
                (onSubmit)="emitSubmit('alarmSettingVeryHigh', $event)"
                (onDelete)="emitDelete('alarmSettingVeryHigh', $event)"
                [channel]="channel"
                [userPermission]="userPermission"
            ></app-alarm-setting-form>
            <app-alarm-setting-form
                #alarmSettingForm
                *ngIf="validators.high"
                [validator]="validators.high"
                title="channel.label.alarm.high"
                [disableFields]="['timer']"
                [alarm]="channel.fcuData.alarmSettingHigh"
                [measurementUnits]="channel.opsData.measurementUnit"
                (onSubmit)="emitSubmit('alarmSettingHigh', $event)"
                (onDelete)="emitDelete('alarmSettingHigh', $event)"
                [channel]="channel"
                [userPermission]="userPermission"
            ></app-alarm-setting-form>
        </div>
        <div class="blank"></div>
    </div>
    <!-- Bottom buttons -->
    <div class="bottom-buttons" *ngIf="openTab == TAB_ALARM">
        <button class="border caption" (click)="emitAdvancedDetails()">
            <mat-icon svgIcon="expand-details" class="details-icon"></mat-icon>
            {{ "forms.channel.alarm.buttons.advanced-settings" | translate }}
        </button>
        <button class="primary caption" (click)="emitClose()">
            {{ "forms.channel.alarm.buttons.close" | translate }}
        </button>
    </div>
</div>

<div class="main-container-about" *ngIf="openTab === TAB_ABOUT">
    <div class="about-continer">
        <div class="about-header">
            {{ "forms.channel.about.input-header" | translate }}
        </div>
        <div class="about-detail-group">
            <div class="column">
                <div class="column-name text highlighted">
                    {{ "forms.channel.about.address" | translate }}
                </div>
                <div class="column-value text light">
                    {{ ADDRESS_STRING + getInputAddress() }}
                </div>
            </div>

            <div class="column">
                <div class="column-name text highlighted">
                    {{ "forms.channel.about.name" | translate }}
                </div>
                <div class="column-value text light">
                    {{ ADDRESS_STRING + getFcuNum() }}
                </div>
            </div>

            <div class="column">
                <div class="column-name text highlighted">
                    {{ "forms.channel.about.channel-type" | translate }}
                </div>
                <div class="column-value text light">
                    {{ getChannelType() }}
                </div>
            </div>
        </div>
    </div>
    <div class="about-continer">
        <div class="about-header">
            {{ "forms.channel.about.output-header" | translate }}
        </div>
        <div class="about-detail-group">
            <div class="column">
                <div class="column-name text highlighted">
                    {{ "forms.channel.about.address" | translate }}
                </div>
                <div class="text light">
                    {{ ADDRESS_STRING + getOutputAddress() }}
                </div>
            </div>
            <div class="column">
                <div class="column-name text highlighted">
                    {{ "forms.channel.about.name" | translate }}
                </div>
                <div class="text light">{{ ADDRESS_STRING + getFcuNum() }}</div>
            </div>
            <div class="column">
                <div class="column-name text highlighted">
                    {{ "forms.channel.about.signal-type" | translate }}
                </div>
                <div class="text light">{{ getOutputSignalType() }}</div>
            </div>
            <div class="column">
                <div class="column-name text highlighted">
                    {{ "forms.channel.about.output-data" | translate }}
                </div>
                <div class="text light">*</div>
            </div>
            <div class="column">
                <div class="column-name text highlighted">
                    {{ "forms.channel.about.signal-data" | translate }}
                </div>
                <div class="text light">
                    {{ "00000000 00000000 00000000 00000000" }}
                </div>
            </div>
        </div>
    </div>

    <div class="about-continer">
        <div class="about-header caption">
            {{ "forms.channel.about.mimics-header" | translate }}
        </div>
        <div class="list-container">
            <div *ngFor="let mimic of mimics" class="mimic-name">
                <button class="border" (click)="toMimicView(mimic.id)">
                    {{ mimic.name }}
                </button>
            </div>
        </div>
    </div>
    <div class="about-continer">
        <div class="about-header caption">
            {{ "forms.channel.about.trend-graphs-header" | translate }}
        </div>
        <div class="list-container">
            <div *ngFor="let trendGraph of trendGraphs">
                <button
                    class="border"
                    (click)="toTrendGraphView(trendGraph.id)"
                >
                    {{ trendGraph.name }}
                </button>
            </div>
        </div>
    </div>
</div>
